import React from 'react'
import { Link } from 'react-router-dom'
import logo from "../assets/logo.png"

function Logo({ hidden, path, className  }) {
  return (
    <Link to={path || "/"} hidden={hidden} className={`flex object-center justify-center items-center text-center text-4xl font-bold text-light_red ${className}`}>
      <img src={logo} alt='Vault' /> <strong className="italic hover:italic text-light_red">erivault</strong>
    </Link>
  )
}

export default Logo